<template>
    <div class="section-title">
        <div class="flex-center">
            <div class="flex">
                <div class="line-left"></div>
                <div class="title">{{titleObj.title||''}}</div>
                <div class="line-right"></div>
            </div>
        </div>
        <div class="tips">{{titleObj.subtitle||''}}</div>
    </div>
</template>

<script>
export default {
    props:{
        titleObj:{
            type:Object,
            default:()=>{
                return {}
            }
        },
    }
}
</script>

<style lang="less" scoped>
.section-title{
    padding:24px 0;
}
.title{
    font-size: 36px;
    color: #333333;
    margin:0 32px;
}
.tips{
    font-size: 16px;
    color: #999999;
    text-align: center;
    margin-top:4px;
}
.line-left{
    width: 160px;
    height: 4px;
    background: linear-gradient(90deg,rgba(249,196,123,0.00), #f9c47b 100%);
}
.line-right{
    width: 160px;
    height: 4px;
    background: linear-gradient(90deg,#f9c47b, rgba(249,196,123,0.00) 100%);
}
</style>